import {ecommerceProductSchema} from '@Component/ShoppingCart/Type/EcommerceProduct';
import {z} from 'zod';

const addProductSuccessResponseSchema = z.object({
    totalQuantity: z.number(),
    shoppingCartSidebar: z.string(),
    shoppingCartTable: z.string(),
    hideShippingLegend: z.boolean(),
    feeMessage: z.string(),
    productid: z.number().optional().nullable(),
    productCode: z.string().optional().nullable(),
    cartType: z.string(),
    ecommerceData: z.object({
        action: z.string(),
        cart: z.array(ecommerceProductSchema),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'product-added': z.array(ecommerceProductSchema),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'product-removed': z.array(ecommerceProductSchema),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'product-quantity-increased': z.array(ecommerceProductSchema),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'product-quantity-decreased': z.array(ecommerceProductSchema),
    }),
});

const addProductFailResponseSchema = z.object({
    error: z.string(),
    message: z.string().optional(),
    productCode: z.string().optional().nullable(),
    productid: z.number().optional().nullable(),
});

export const addProductResponseSchema = z.union([addProductSuccessResponseSchema, addProductFailResponseSchema]);

export type AddProductResponse = z.infer<typeof addProductResponseSchema>;
